import React, { useEffect, useState } from 'react'
import { Col, Empty, Row, Skeleton } from 'antd'
import { useHistory } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
  WhiteCol,
  TransparentCol,
  Colordiv,
  TransaparentDiv,
  QuickLinksContainer,
  SingleLink,
  SingleLinkSVG,
  SingleLinkText,
  SingleTopic,
  View,
  FeedsContainer,
  AdsContainer,
  FeedsContent,
  TopUsersContainer,
  Searchbar,
} from './style'
import { motion } from 'framer-motion'
import {
  componentTransition,
  componentTransitionProp,
} from '../../animation/index'
import { BsEyeFill, BsSearch } from 'react-icons/bs'
import {
  FcGraduationCap,
  FcDepartment,
  FcGlobe,
  FcAssistant,
  FcDebt,
} from 'react-icons/fc'
import { FETCH_SEARCH_QUESTIONS } from '../../app/apollo'
import PostCard from '../../globalComponents/PostCard'
import { useLazyQuery } from '@apollo/client'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
  feedReducer,
  handleAllPages,
  handleCurrentPage,
  handlefeedList,
} from './slice'
import { NotificationAlert } from '../../utils/NotificationAlert'

const Home: React.FC = () => {
  var feeds = useAppSelector(feedReducer)
  var dispatcher = useAppDispatch()
  const usersArray = [
    {
      id: 1,
      img:
        'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1480&q=80',
      name: 'Akinola Ike',
      rank: 'Expert',
    },
    {
      id: 2,
      img:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80',
      name: 'Akinola Ike',
      rank: 'Expert',
    },
    {
      id: 3,
      img:
        'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=988&q=80',
      name: 'Akinola Ike',
      rank: 'Expert',
    },
    {
      id: 4,
      img:
        'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=987&q=80',
      name: 'Akinola Ike',
      rank: 'Experienced',
    },
    {
      id: 5,
      img:
        'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80',
      name: 'Akinola Ike',
      rank: 'Intermediate',
    },
    {
      id: 6,
      img:
        'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=988&q=80',
      name: 'Akinola Ike',
      rank: 'Beginner',
    },
  ]
  const postsArray = [
    {
      id: 1,
      userImage:
        'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80',
      commentCount: 10,
      approvedComments: 2,
      name: 'Ajala Ike',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti aperiam libero? Veritatis esse eos dicta.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What is the name of your forefathers?',
      createdAt: '4hr ago',
    },
    {
      id: 2,
      userImage:
        'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80',
      commentCount: 8,
      approvedComments: 7,
      name: 'Ike Ike',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti leniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What the fuck are you?',
      createdAt: '10hr ago',
    },
    {
      id: 3,
      userImage:
        'https://images.unsplash.com/photo-1557862921-37829c790f19?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2071&q=80',
      commentCount: 9,
      approvedComments: 0,
      name: 'John Conor',
      description:
        'Adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti leniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What is this lady saying?',
      createdAt: '23hr ago',
    },
    {
      id: 4,
      userImage:
        'https://images.unsplash.com/photo-1554151228-14d9def656e4?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=986&q=80',
      commentCount: 10,
      approvedComments: 2,
      name: 'Ajala Ike',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti aperiam libero? Veritatis esse eos dicta.Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What is the name of your forefathers?',
      createdAt: '4hr ago',
    },
    {
      id: 5,
      userImage:
        'https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2070&q=80',
      commentCount: 8,
      approvedComments: 7,
      name: 'Ike Ike',
      description:
        'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti leniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What the fuck are you?',
      createdAt: '10hr ago',
    },
    {
      id: 6,
      userImage:
        'https://images.unsplash.com/photo-1557862921-37829c790f19?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2071&q=80',
      commentCount: 9,
      approvedComments: 0,
      name: 'John Conor',
      description:
        'Adipisicing elit. Quibusdam fuga ullam optio eveniet commodi architecto in, a quisquam iste inventore minima veniam at deleniti leniti aperiam libero? Veritatis esse eos dicta.',
      topic: 'What is this lady saying?',
      createdAt: '23hr ago',
    },
  ]
  const [loading, setLoading] = useState(false)
  const [searchQuestions, searchQuestionsData] = useLazyQuery(
    FETCH_SEARCH_QUESTIONS,
  )
  useEffect(() => {
    if (searchQuestionsData?.error) {
      NotificationAlert('error', 'Error Occured', 'Kindly reload')
      setLoading(false)
    } else if (searchQuestionsData?.data?.searchQuestions) {
      setLoading(false)
      dispatcher(
        handlefeedList([
          ...feeds?.feedList,
          ...searchQuestionsData?.data?.searchQuestions?.questions,
        ]),
      )
      dispatcher(
        handleAllPages(+searchQuestionsData?.data?.searchQuestions?.last_page),
      )
      dispatcher(
        handleCurrentPage(
          +searchQuestionsData?.data?.searchQuestions?.current_page,
        ),
      )
    }
  }, [searchQuestionsData])
  console.log('search', searchQuestionsData)
  useEffect(() => {
    handleSearchQuestions('', 'multi', '', 1)
  }, [])
  const handleSearchQuestions = async (
    byTags?: any,
    byTitle?: any,
    byDescription?: any,
    requestedPage?: any,
  ) => {
    setLoading(true)

    try {
      await searchQuestions({
        variables: {
          byTags,
          byTitle,
          byDescription,
          requestedPage: +requestedPage,
          itemsPerPage: 15,
        },
      })
    } catch (e) {
      setLoading(false)
      console.log('search error', e)
    }
  }
  const history = useHistory()
  const topUserList = usersArray.map((user) => {
    return (
      <div key={user.id}>
        <img src={user?.img} alt={user.name} />
        <h5>{user.name}</h5>
        <span>{user.rank}</span>
      </div>
    )
  })
  const fetchMoreData = () => {
    if (feeds?.currentPage < feeds?.allPages) {
      handleSearchQuestions('', 'multi', '', feeds?.currentPage + 1)
      handleCurrentPage(feeds?.currentPage + 1)
    }
  }

  return (
    <motion.div
      variants={componentTransition}
      initial="initial"
      animate="in"
      exit="out"
      transition={componentTransitionProp}
    >
      <Row justify="space-between">
        <TransparentCol md={{ span: 15 }}>
          <TransaparentDiv>
            <Searchbar>
              <div onClick={() => history.push('/home/search')}>
                <BsSearch /> <p>search</p>
              </div>
            </Searchbar>
            {/* <Posts /> */}
            <InfiniteScroll
              dataLength={feeds?.feedList?.length}
              next={fetchMoreData}
              hasMore={feeds?.currentPage < feeds?.allPages && true}
              loader={<Skeleton active />}
            >
              {feeds?.feedList?.length > 0 && (
                <PostCard posts={feeds?.feedList} />
              )}
            </InfiniteScroll>
            {feeds?.feedList?.length < 1 && loading && <Skeleton active />}
            {feeds?.feedList?.length < 1 && !loading && <Empty />}
          </TransaparentDiv>
        </TransparentCol>
        <WhiteCol md={{ span: 9 }}>
          <Colordiv>
            <h2>Top Users</h2>
            <TopUsersContainer>
              {topUserList}
              <div>
                <img
                  src={`https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1480&q=80`}
                  alt="My name"
                />
                <h5>Me</h5>
                <span>None</span>
              </div>
            </TopUsersContainer>
            {/* <QuickLinks /> */}
            {/* <h2>Trending Discussion</h2> */}
            {/* <TrendingTopics /> */}
          </Colordiv>
        </WhiteCol>
      </Row>
    </motion.div>
  )
}

export default Home

const linksArray = [
  {
    id: 1,
    svg: <FcDepartment />,
    title: 'Accomodation',
    description:
      'Do you need a new accomodation and a place to stay, click this tab to navigate to our list of service providers... i need more text ',
    color: '#1A2A98',
  },
  {
    id: 2,
    svg: <FcDebt />,
    title: 'Occupation/Job',
    description:
      'Do you need a new job? and a place to stay, click this tab to navigate to our list of service providers... i need more text',
    color: '#F7241A',
  },
  {
    id: 3,
    svg: <FcGraduationCap />,
    route: '/home/education',
    title: 'Education',
    description:
      'Do you need a new school and a place to stay, click this tab to navigate to our list of service providers... i need more text',
    color: '#839472',
  },
  {
    id: 4,
    svg: <FcAssistant />,
    title: 'Services',
    route: '/home/services',

    description:
      'Search for fun places. Odio velit sequi vitae mollitia consectetur labore maxime libero ad. Porro ut itaque libero consequuntur sed earum assumenda provident nemo odio error!',
    color: '#020205',
  },
  {
    id: 5,
    svg: <FcGlobe />,
    title: 'Tour',
    description:
      'Search for fun places. Odio velit sequi vitae mollitia consectetur labore maxime libero ad. Porro ut itaque libero consequuntur sed earum assumenda provident nemo odio error!',
    color: '#B5B8CB',
  },
]

const QuickLinks = () => {
  const history = useHistory()
  const routeLocate = (route: any) => {
    history.push(route)
  }

  const links = linksArray.map((link) => (
    <SingleLink key={link.id} onClick={() => routeLocate(link.route)}>
      <SingleLinkSVG color={link.color}>{link.svg}</SingleLinkSVG>
      <SingleLinkText>
        <h1>{link.title}</h1>
        <p>{link.description}</p>
      </SingleLinkText>
    </SingleLink>
  ))
  return <QuickLinksContainer>{links}</QuickLinksContainer>
}

const trendingArray = [
  {
    id: 1,
    description:
      'The world on earth is Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1554384645-13eab165c24b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=375&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
  {
    id: 2,
    description:
      'The world on earth is Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=333&q=80`,
    creatorName: 'Ruth Onoolapo',
    members: '1234',
  },
  {
    id: 3,
    description:
      'The world on earth is very Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80`,
    creatorName: 'Gbade Tayo',
    members: '1234',
  },
  {
    id: 4,
    description:
      'The world on earth is very  Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1560787313-5dff3307e257?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
  {
    id: 5,
    description:
      'The world on earth is very  Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1560787313-5dff3307e257?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
  {
    id: 6,
    description:
      'The world on earth is Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1554384645-13eab165c24b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=375&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
  {
    id: 7,
    description:
      'The world on earth is Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=333&q=80`,
    creatorName: 'Ruth Onoolapo',
    members: '1234',
  },
  {
    id: 8,
    description:
      'The world on earth is very Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80`,
    creatorName: 'Gbade Tayo',
    members: '1234',
  },
  {
    id: 9,
    description:
      'The world on earth is very  Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1560787313-5dff3307e257?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
  {
    id: 10,
    description:
      'The world on earth is very  Porro ut itaque libero consequuntur sed earum assumenda provident',
    creator: `https://images.unsplash.com/photo-1560787313-5dff3307e257?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
    creatorName: 'Shola King',
    members: '1234',
  },
]

const TrendingTopics = () => {
  const trending = trendingArray.map((trend) => (
    <Col key={trend.id} md={{ span: 12 }}>
      {' '}
      <SingleTopic>
        <p>{trend.description}</p>
        <div>
          {' '}
          <img src={trend.creator} alt={trend.creatorName} />
          <div>
            <p>{trend.creatorName}</p>
            <h5>{trend.members} listenerss</h5>
          </div>
        </div>
      </SingleTopic>
    </Col>
  ))
  return (
    <QuickLinksContainer>
      <Row justify="space-between">
        {trending}
        <View>
          <div>
            <BsEyeFill />{' '}
          </div>
          <p>see more discussions...</p>
        </View>
      </Row>
    </QuickLinksContainer>
  )
}

const postsArray = [
  {
    id: 1,
    ads: false,
    poster: 'Ruth Otedola',
    location: 'oklahoma',
    postimage: `https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=343&q=80`,
    details:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.',
    userimage: `https://images.unsplash.com/photo-1560787313-5dff3307e257?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
  },
  {
    id: 4,
    ads: true,
    specification: 'Senior Backend developer',
    contactmail: 'hfyrykrw@gmail.com',
    description:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.',
  },

  {
    id: 2,
    ads: false,
    poster: 'Gbade Otedola',
    location: 'U.S.A',
    postimage: `https://images.unsplash.com/photo-1513116476489-7635e79feb27?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=684&q=80`,
    details:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.',
    userimage: `https://images.unsplash.com/photo-1554384645-13eab165c24b?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=375&q=80`,
  },
  {
    id: 3,
    ads: false,
    poster: 'Gbade Test',
    location: 'U.S.A',
    postimage: `https://images.unsplash.com/photo-1491637639811-60e2756cc1c7?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1938&q=80`,
    details:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.',
    userimage: `https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80`,
  },
  {
    id: 5,
    ads: true,
    specification: 'Senior Backend developer',
    contactmail: 'hfyrykrw@gmail.com',
    description:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.s',
  },
  {
    id: 6,
    ads: false,
    poster: 'Another User ',
    location: 'U.K',
    postimage: `https://images.unsplash.com/photo-1546868871-7041f2a55e12?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1900&q=80`,
    details:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Necessitatibus saepe, quibusdam nemo in consectetur totam distinctio illo ab earum? Excepturi delectus in doloremque dolor iure quo nihil voluptate dolores? Et.',
    userimage: `https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=334&q=80`,
  },
]

const Posts = () => {
  const feedsList = postsArray.map((post) =>
    post.ads ? (
      <FeedsContainer>
        <AdsContainer>
          <div>
            <div>
              <h3>{post.specification}</h3>
              <h4>contact:{post.contactmail}</h4>
            </div>
            <h5>ads</h5>
          </div>
          <h3>{post.description}</h3>
        </AdsContainer>
      </FeedsContainer>
    ) : (
      <FeedsContainer>
        <FeedsContent>
          <div>
            <img src={post.userimage} alt="" />
            <div>
              <h3>{post.poster}</h3>
              <h4>{post.location}</h4>
            </div>
          </div>
          <h3>{post.details}</h3>
          <img src={post.postimage} alt="" />
        </FeedsContent>
      </FeedsContainer>
    ),
  )
  return (
    <>
      {/* <ChatContainer>
        <TypeMessageContainer>
          <img
            src={`https://images.unsplash.com/photo-1589156280159-27698a70f29e?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1866&q=80`}
            alt="ruth"
          />
          <StyledInput
            autoSize={{ minRows: 1, maxRows: 3 }}
            bordered={false}
            placeholder="Share your thoughts..."
          />
        </TypeMessageContainer>
        <SendContainer>
          <Row>
            <Col md={{ span: 6 }}>
              <ConfirmSend>
                <p>
                  <VscDeviceCamera />
                </p>
                Photo
              </ConfirmSend>
            </Col>
            <Col md={{ span: 6 }}>
              <ConfirmSend>
                <p>
                  <BsCameraVideo />
                </p>
                Video
              </ConfirmSend>
            </Col>
            <Col md={{ span: 6 }}>
              <ConfirmSend>
                <p>
                  <AiOutlineFile />
                </p>
                File
              </ConfirmSend>
            </Col>
            <Col md={{ span: 6 }}>
              <Send>Post</Send>
            </Col>
          </Row>
        </SendContainer>
      </ChatContainer> */}
      {feedsList}
    </>
  )
}
